<ng-content></ng-content>
@if (isRequiredSymbolVisible()) {
  <span class="label__symbol">*</span>
}
